module.exports = __webpack_public_path__ + "static/media/RAR.5dc8a66e.svg";